import { useTheme } from "@mui/material";
import React from "react";

const BossBouncerLogo2 = () => {
  const theme = useTheme();
  return (
    <svg
      fill={theme.palette.mode === "light" ? "black" : "white"}
      height="36"
      viewBox="0 0 32 32"
      width="36"
      style={{ margin: "10px 0px 0px 10px" }}
    >
      <path
        fill={theme.palette.mode === "light" ? "black" : "white"}
        d="M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5"
      ></path>
    </svg>
  );
};

export default BossBouncerLogo2;
